const Logotipo = () => {
  return (
    <div className="text-center py-10 px-2">
      {/* <h1 className='uppercase font-bold tracking-[4px]'>Tu logo</h1> */}
      <img src="images/logoSidebar.svg" alt="Image" />
    </div>
  );
};
export default Logotipo;